import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + process.env.VUE_APP_API_ACCESS_TOKEN;
axios.defaults.headers.common['Accept'] = 'application/json';

window.axios = axios;